import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {
  ToggleButton as MUIToggleButton,
  ToggleButtonGroup as MUIToggleButtonGroup,
  Menu,
  Tooltip,
} from '@mui/material';
import {styled} from '@mui/material/styles';

import TransparentImage from '../../assets/images/transparent.jpg';

export const DownloadButton = styled(Button)(({theme}) => ({
  marginRight: theme.spacing(1),
}));

export const FooterSwatch = ({
  gradient = false,
  transparent = false,
  ...props
}) => (
  <Box
    width={18}
    height={18}
    borderRadius={1}
    sx={{
      background: theme =>
        gradient
          ? `linear-gradient(to top, black, ${theme.palette.primary.main})`
          : '',
      backgroundImage: transparent ? `url(${TransparentImage})` : '',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    }}
    {...props}
  />
);

FooterSwatch.propTypes = {
  gradient: PropTypes.bool,
  transparent: PropTypes.bool,
};

export const ToggleButton = React.forwardRef(
  ({sx, tooltipTitle, ...props}, ref) => (
    <Tooltip title={tooltipTitle} placement="bottom">
      <MUIToggleButton
        ref={ref}
        size="small"
        color="primary"
        sx={[
          {
            '&:not(:first-of-type)': {ml: 1},
            border: 'none',
            backgroundColor: 'red',
            '&.MuiToggleButton-root': {
              border: 'none',
            },
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...props}
      />
    </Tooltip>
  )
);

ToggleButton.propTypes = {
  sx: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  tooltipTitle: PropTypes.string,
};

export const SnapshotMenuButton = ({
  label,
  children,
  tooltipTitle,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <ToggleButton
        color="standard"
        tooltipTitle={tooltipTitle}
        value={tooltipTitle}
        onClick={handleClick}
        selected={Boolean(anchorEl)}
        sx={{
          minWidth: 40,
          width: 40,
          height: 40,
        }}
        {...props}
      >
        {label}
      </ToggleButton>
      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{sx: {marginTop: 0.5}}}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
      >
        {children}
      </Menu>
    </React.Fragment>
  );
};

SnapshotMenuButton.propTypes = {
  label: PropTypes.node,
  children: PropTypes.node,
  tooltipTitle: PropTypes.string,
};

export const ToggleButtonGroup = props => (
  <MUIToggleButtonGroup
    size="small"
    exclusive
    sx={{
      paddingX: 1,
      '& .MuiToggleButtonGroup-grouped': {
        margin: 0.5,
        '&:not(:first-of-type)': {
          borderRadius: 1,
        },
        '&:first-of-type': {
          borderRadius: 1,
        },
      },
    }}
    {...props}
  />
);
// export const ToggleButtonGroup = styled(ToggleButtonGroupUI)(({theme}) => ({
//   width: '100%',
//   marginBottom: theme.spacing(2),
//   display: 'flex',
//   '& button': {
//     flexGrow: 1,
//   },
// }));
